<script>
export default {
  props: {
    certifications: {
      type: Array,
      default: function() {
        return []
      },
    },
  },
}
</script>

<template>
  <section>
    <span v-if="certifications && certifications.length > 0" class="caption">
      {{ $t('booking.certificationsLabel') }}:
    </span>
    <v-chip
      v-for="cert in certifications"
      :key="cert.id"
      :class="['transparent']"
      small
      label
      outlined
    >
      {{ `${cert.title} #${cert.reference}` }}
    </v-chip>
  </section>
</template>
